







































import {Component, Vue} from 'vue-property-decorator'
import CodigoBarra from '@/model/resource/CodigoBarra'

export interface OptionDisplay {
  title: string
  idFilter: number
}

@Component
export default class ModalBarcodeDisplay extends Vue {
  codigoBarras: CodigoBarra[] | null = null
  options: OptionDisplay[] = [
    {
      title : 'component.RenderCargaBarcode.headerRecebidos' ,
      idFilter: 2,
    },
    {
      title : 'component.RenderCargaBarcode.headerEntregues' ,
      idFilter: 3,
    },
    {
      title : 'component.RenderCargaBarcode.headerPendentesEntrega' ,
      idFilter: 4,
    },
    {
      title : 'component.RenderCargaBarcode.header' ,
      idFilter: 1,
    },
  ]

  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event: KeyboardEvent) {
    if ((event.key === 'Escape' || event.key === 'Esc') && this.codigoBarras !== null) {
      this.close()
    }
  }

  async openEvent(codigoBarras: CodigoBarra[]) {
    this.$emit('open')
    this.codigoBarras = codigoBarras
  }

  closeEvent() {
    this.codigoBarras = null
    this.$emit('close')
  }

  filterCodigoBarra(val: number | null): CodigoBarra[] | null {
    if (this.codigoBarras === null) return null
    if (!val) return this.codigoBarras
    if (val === 1) return this.codigoBarras.filter((it) => it.idTipoCodigoBarra === val || it.idTipoCodigoBarra === 0)
    return this.codigoBarras.filter((it) => it.idTipoCodigoBarra === val)
  }

  close() {
    this.$modal.close('barcodeDisplay')
  }
}
